const Facebook = {
  enable() {
    !(function (f, b, e, v, n) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  paso1() {
    window.fbq("trackCustom", "Ver contenido", {
      content_type: "Nominas_jubilados"
    });
  },
  gracias() {
    window.fbq("trackCustom", "Comprar", {
      content_type: "Nominas_jubilados"
    });
  },
  mensaje(context) {
    const mje = Number(context.mutation.payload.params.mje);

    if (mje === 0) {
      // ya registrado
      return window.fbq("track", "PageView", {
        content_type: "Nominas_jubilados"
      });
    }
    if (mje === 1) {
      // no hay cupo
      return window.fbq("trackCustom", "Completar registro", {
        content_type: "Nominas_jubilados"
      });
    }
  }
};

export default Facebook;
